import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface PushPermissionPromptProps {
  opened: boolean;
  onAllow: () => void;
  onDismiss: () => void;
}

export function PushPermissionPrompt({
  opened,
  onAllow,
  onDismiss,
}: PushPermissionPromptProps) {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onDismiss}
      title={t("notifications.pushPrompt.title")}
      centered
      data-testid="push-permission-prompt"
    >
      <Stack gap="md">
        <Text size="sm">{t("notifications.pushPrompt.description")}</Text>
        <Group justify="flex-end">
          <Button
            variant="subtle"
            onClick={onDismiss}
            data-testid="push-permission-prompt-dismiss"
          >
            {t("notifications.pushPrompt.dismiss")}
          </Button>
          <Button onClick={onAllow} data-testid="push-permission-prompt-allow">
            {t("notifications.pushPrompt.allow")}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
